/* =============================================
   SCORPIUS ANIMATIONS & NEW-SECTION LOGIC
   - Animated stat counters
   - Staggered reveal / heading underline
   - FAQ live search filter
   - Fleet ROI calculator
   - Hero parallax (light, passive)
   All native APIs. Respects prefers-reduced-motion.
   ============================================= */
(function(){
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(s, r){ return (r || document).querySelector(s); }
  function $$(s, r){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------- 1. STAT COUNTERS ---------- */
  function easeOutCubic(t){ return 1 - Math.pow(1 - t, 3); }

  function formatNumber(n){
    return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function runCounter(el){
    if (el.dataset.counted) return;
    el.dataset.counted = '1';
    var target = parseFloat((el.dataset.countTo || '0').replace(/[^0-9.]/g, '')) || 0;
    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var duration = parseInt(el.dataset.duration, 10) || 1400;

    if (reduceMotion || target === 0){
      el.textContent = prefix + formatNumber(target) + suffix;
      return;
    }

    var start = null;
    function step(ts){
      if (!start) start = ts;
      var progress = Math.min((ts - start) / duration, 1);
      var value = target * easeOutCubic(progress);
      el.textContent = prefix + formatNumber(value) + suffix;
      if (progress < 1){ requestAnimationFrame(step); }
      else { el.textContent = prefix + formatNumber(target) + suffix; }
    }
    requestAnimationFrame(step);
  }

  function initCounters(){
    var counters = $$('[data-count-to]');
    if (!counters.length) return;
    if (!('IntersectionObserver' in window)){ counters.forEach(runCounter); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ runCounter(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    counters.forEach(function(c){ io.observe(c); });
  }

  /* ---------- 2. STAGGERED REVEAL / UNDERLINE DRAW ---------- */
  function initVisibility(){
    var targets = $$('.case-card, .pricing-table__table tbody tr, .t-h2--draw, .resource-card');
    if (!targets.length) return;
    if (!('IntersectionObserver' in window) || reduceMotion){
      targets.forEach(function(t){ t.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting){ e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    targets.forEach(function(t){ io.observe(t); });
  }

  /* ---------- 3. FAQ LIVE SEARCH ---------- */
  function initFaqSearch(){
    var input = $('#faq-search-input');
    if (!input) return;
    var list = $('#faq-search-list');
    var empty = $('#faq-search-empty');
    var items = $$('.faq-item', list);

    input.addEventListener('input', function(){
      var q = input.value.trim().toLowerCase();
      var visible = 0;
      items.forEach(function(item){
        var text = item.getAttribute('data-faq-text') || '';
        var match = q === '' || text.indexOf(q) > -1;
        item.style.display = match ? '' : 'none';
        if (match) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
    });
  }

  /* ---------- 4. FLEET ROI CALCULATOR ---------- */
  function initRoiCalc(){
    var root = $('#roi-calc');
    if (!root) return;
    var prices = window.BUY_BACK_PRICES;
    var countEl = $('#roi-count');
    var modelEl = $('#roi-model');
    var gradeEl = $('#roi-grade');
    var valueEl = $('#roi-value');
    var co2El = $('#roi-co2');
    var unitsEl = $('#roi-units');
    var ctaEl = $('#roi-cta');
    if (!countEl || !modelEl || !gradeEl) return;

    if (prices && modelEl.options.length <= 1){
      Object.keys(prices).forEach(function(m){
        var o = document.createElement('option');
        o.value = m; o.textContent = m;
        modelEl.appendChild(o);
      });
    }

    var co2Per = parseInt((valueEl && valueEl.dataset.co2Per) || '70', 10);

    function recalc(){
      var count = Math.max(0, parseInt(countEl.value, 10) || 0);
      var model = modelEl.value;
      var grade = gradeEl.value;
      var unit = (prices && prices[model] && prices[model][grade]) || 0;
      var total = unit * count;
      var co2 = count * co2Per;
      if (valueEl) valueEl.textContent = '£' + formatNumber(total);
      if (co2El) co2El.textContent = formatNumber(co2) + ' kg';
      if (unitsEl) unitsEl.textContent = formatNumber(count);
      if (ctaEl){
        var base = ctaEl.getAttribute('href').split('?')[0];
        var note = 'Fleet enquiry: ' + count + ' x ' + model + ' (Grade ' + grade + '), est. value GBP ' + formatNumber(total);
        ctaEl.setAttribute('href', base + '?roi=' + encodeURIComponent(note));
        try { sessionStorage.setItem('roi_quote', note); } catch(e){}
      }
    }
    countEl.addEventListener('input', recalc);
    modelEl.addEventListener('change', recalc);
    gradeEl.addEventListener('change', recalc);
    recalc();
  }

  /* ---------- 5. HERO PARALLAX (light, passive) ---------- */
  function initParallax(){
    if (reduceMotion) return;
    var grid = $('.hero__grid');
    var device = $('.hero__device');
    if (!grid && !device) return;
    var ticking = false;
    function onScroll(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        var y = window.pageYOffset;
        if (y < 900){
          if (grid) grid.style.transform = 'translateY(' + (y * 0.18) + 'px)';
          if (device) device.style.transform = 'translateY(' + (y * -0.08) + 'px)';
        }
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- 6. HERO HEADLINE WORD RISE ---------- */
  function splitWords(el, counter){
    var nodes = Array.prototype.slice.call(el.childNodes);
    el.innerHTML = '';
    nodes.forEach(function(node){
      if (node.nodeType === 3){ // text node
        node.textContent.split(/(\s+)/).forEach(function(part){
          if (part === '') return;
          if (/^\s+$/.test(part)){ el.appendChild(document.createTextNode(part)); return; }
          var w = document.createElement('span');
          w.className = 'hword';
          w.style.setProperty('--w', counter.i++);
          w.textContent = part;
          el.appendChild(w);
        });
      } else if (node.nodeType === 1){ // element e.g. <em>
        var wrap = node.cloneNode(false);
        splitWords(node, counter);
        while (node.firstChild){ wrap.appendChild(node.firstChild); }
        el.appendChild(wrap);
      } else {
        el.appendChild(node);
      }
    });
  }

  function initHeroHeadline(){
    if (reduceMotion) return;
    var h = document.querySelector('.hero__headline');
    if (!h || h.dataset.split) return;
    h.dataset.split = '1';
    splitWords(h, { i: 0 });
  }

  /* ---------- 7. STICKY QUOTE BUTTON ---------- */
  function initStickyQuote(){
    var el = document.getElementById('sticky-quote');
    if (!el || el.dataset.bound) return;
    el.dataset.bound = '1';
    function toggle(){ el.classList.toggle('is-visible', window.pageYOffset > 500); }
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  /* ---------- INIT ---------- */
  function init(){
    initCounters();
    initVisibility();
    initFaqSearch();
    initRoiCalc();
    initParallax();
    initHeroHeadline();
    initStickyQuote();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
